import { useEffect, useState } from "react";
import { getHouseTaskHistory, type HouseTaskHistoryResult } from "../lib/familyLists";

export function HouseTaskHistory({ householdId, memberUid, refreshKey }: {
  householdId: string; memberUid: string; refreshKey: string;
}) {
  const [history, setHistory] = useState<HouseTaskHistoryResult | null>(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(true);
  const [retry, setRetry] = useState(0);
  const [visible, setVisible] = useState(20);
  useEffect(() => {
    let cancelled = false;
    setHistory(null); setError(false); setLoading(true); setVisible(20);
    getHouseTaskHistory(householdId, memberUid).then((result) => {
      if (!cancelled) setHistory(result);
    }).catch(() => { if (!cancelled) setError(true); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [householdId, memberUid, refreshKey, retry]);

  if (loading) return <p role="status">Loading chore earnings…</p>;
  if (error || !history) return <p role="status">Chore earnings couldn’t load. <button type="button" onClick={() => setRetry(retry + 1)}>Try again</button></p>;
  return <section className="house-earnings" aria-label="Chore earnings ledger">
    <div className="house-earnings-total"><div><strong>{history.memberName} · Total earned</strong><small>Paid when approved</small></div><b>{history.totalEarned.toLocaleString()} <span>FamBucks</span></b></div>
    {history.entries.length === 0 ? <p>No approved chore earnings yet.</p> : <>
      <div className="house-table-shell"><table className="house-task-table house-earnings-table" aria-label="Approved chore earnings">
        <colgroup><col /><col style={{ width: "29%" }} /><col style={{ width: "48px" }} /></colgroup>
        <thead><tr><th scope="col">Task / Who</th><th scope="col">Approved</th><th scope="col" className="house-points"><abbr title="FamBucks">FB</abbr></th></tr></thead>
        <tbody>{history.entries.slice(0, visible).map((entry) => <tr key={entry.id}>
          <td><strong>{entry.task}</strong><small>{history.memberName}{entry.completionNumber && entry.completionNumber > 1 ? ` · Completion ${entry.completionNumber}` : ""}</small></td>
          <td>{entry.approvedAt ? <time dateTime={entry.approvedAt}>{new Date(entry.approvedAt).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric", timeZone: "America/Los_Angeles" })}</time> : "Date unavailable"}</td>
          <td className="house-points">+{entry.points}</td>
        </tr>)}</tbody>
      </table></div>
      {visible < history.entries.length && <button type="button" className="house-section-toggle" onClick={() => setVisible(visible + 20)}>Show more earnings</button>}
    </>}
  </section>;
}
